/* unplugin-vue-components disabled */import { render } from "./BlankLayout.vue?vue&type=template&id=059e9690"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.9.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__